export default __webpack_public_path__ + "static/media/goldman-sachs.e651bae3.svg";